import { render, staticRenderFns } from "./investment-return-filter.vue?vue&type=template&id=09490132"
import script from "./investment-return-filter.vue?vue&type=script&lang=js"
export * from "./investment-return-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports